import React from 'react';
import { useNavigate } from 'react-router-dom';
import './AppNavbar.css';
import logoImage from '../assets/images/logo.png';

const AppNavbar = ({
  brandLabel = 'REELO',
  brandTo = '/dashboard',
  navigationItems = [],
  user,
  onLogout,
  showUserSection = true,
  className = ''
}) => {
  const navigate = useNavigate();

  const handleNavigation = (item) => {
    if (typeof item.onClick === 'function') {
      item.onClick();
      return;
    }

    if (item.to) {
      navigate(item.to);
    }
  };

  const handleBrandClick = () => {
    navigate(brandTo);
  };

  return (
    <nav className={`app-navbar ${className}`.trim()}>
      <div className="app-navbar-brand">
        <button type="button" className="app-navbar-brand-button" onClick={handleBrandClick}>
          <img src={logoImage} alt={brandLabel} className="app-navbar-brand-logo" />
          <span className="app-navbar-brand-text">{brandLabel}</span>
        </button>
      </div>

      {navigationItems.length > 0 && (
        <div className="app-navbar-links">
          {navigationItems.map((item) => (
            <button
              key={`${item.label}-${item.to || 'action'}`}
              type="button"
              className={`app-navbar-link ${item.isActive ? 'active' : ''}`.trim()}
              onClick={() => handleNavigation(item)}
            >
              {item.label}
            </button>
          ))}
        </div>
      )}

      {showUserSection && (
        <div className="app-navbar-user">
          {user?.profileImage && (
            <img
              src={user.profileImage}
              alt="Profile"
              className="app-navbar-avatar"
            />
          )}
          <span>Welcome, {user?.name || user?.email || 'User'}</span>
          {typeof onLogout === 'function' && (
            <button type="button" onClick={onLogout} className="app-navbar-logout-button">
              Logout
            </button>
          )}
        </div>
      )}
    </nav>
  );
};

export default AppNavbar;
